// 存放第三方链接

export default {
  OUTLOOK_ADD: "https://outlook.live.com/calendar/0/deeplink/compose",
  LINE_SHARE_TXT: "https://line.me/R/share",
  ZHIY_CC: "https://zhiy.cc/",
  PARAGRAPH_XYZ: "https://paragraph.xyz/",
  HUPU_BBS: "https://bbs.hupu.com/",
  BENTO_ME: "https://bento.me/",
  BOOKING_COM: "https://booking.com/",
  CODA_IO: "https://coda.io/",
  M_CNBETA: "https://m.cnbeta.com.tw/",
  SPEAKERDECK_COM: "https://speakerdeck.com/",

  // about search
  BING_SEARCH: "https://www.bing.com/search",
  FELO_SEARCH: "https://felo.ai/search",
  SOUGO_SEARCH: "https://m.sogou.com/web/searchList.jsp",
  XHS_SEARCH: "https://www.xiaohongshu.com/search_result",

  // 果壳
  GUOKR_COM: "https://guokr.com/",

  // street voice
  STREET_VOICE: "https://streetvoice.com/",

  // spotify
  SPOTIFY_OPEN: "https://open.spotify.com/",

  // github
  GITHUB_GIST: "https://gist.github.com/",
  GITHUB_OAUTH: "https://github.com/login/oauth/authorize",
  GITHUB_SEARCH: "https://github.com/search",

  // wechat
  WX_GZH_OAUTH: "https://open.weixin.qq.com/connect/oauth2/authorize",

  // apple music
  APPLE_MUSIC: "https://music.apple.com/",
  APPLE_MUSIC_EMBED: "https://embed.music.apple.com/",

  // apple podcast
  APPLE_PODCAST: "https://podcasts.apple.com/",
  APPLE_PODCAST_EMBED: "https://embed.podcasts.apple.com/",

  // telegram
  T_ME: "https://t.me/",
  TELEGRAM_WIDGETS: "https://telegram.org/js/telegram-widget.js?22",

  // typeform
  TYPEFORM_TO: "https://typeform.com/to/",

  // producthunt card
  PRODUCTHUNT_CARD: "https://cards.producthunt.com/cards/posts/",

  // calendly
  CALENDLY_COM: "https://calendly.com/",
  CALENDLY_WIDGETS: "https://assets.calendly.com/assets/external/widget.js",

  // twitter
  TWITTER_COM: "https://twitter.com/",
  TWITTER_ADD: "https://twitter.com/intent/tweet",
  TWITTER_WIDGETS: "https://platform.twitter.com/widgets.js",
  X_COM: "https://x.com/",


  // bilibili
  BILIBILI_COMMON: "https://www.bilibili.com/video/__XXX__/",
  BILIBILI_PLAYER: "https://player.bilibili.com/player.html?bvid=__XXX__",

  // loom
  LOOM_SHARE: "https://www.loom.com/share/__XXX__",
  LOOM_EMBED: "https://www.loom.com/embed/__XXX__",

  // Google
  GOOGLE_DOCS: "https://docs.google.com/",    // google docs
  GOOGLE_MAPS: "https://www.google.com/maps/",   // google maps embed
  GOOGLE_CALENDAR_ADD: "https://calendar.google.com/calendar/u/0/r/eventedit",
  GOOGLE_SEARCH: "https://www.google.com/?igu=1",
  GOOGLE_GIS_SCRIPT: "https://accounts.google.com/gsi/client",
  GOOGLE_OAUTH2: "https://accounts.google.com/o/oauth2/v2/auth",

  // youtube
  YOUTUBE_EMBED: "https://www.youtube.com/embed/__XXX__?autoplay=1",
  YOUTUBE_SHORT: "https://youtu.be/__XXX__",
  YOUTUBE_WATCH: "https://www.youtube.com/watch?v=__XXX__",
  YOUTUBE_PLAYLIST: "https://www.youtube.com/playlist?list=__XXX__",
  YOUTUBE_VIDEOSERIES: "https://www.youtube.com/embed/videoseries?list=__XXX__",

  // warp
  WARP_DEV: "https://app.warp.dev/block/",

  // figma
  FIGMA_EMBED: "https://www.figma.com/embed?embed_host=share&url=__XXX__",

  // one drive & office
  ONEDRIVE_EMBED: "https://onedrive.live.com/embed",

  // instagram
  IG_P: "https://www.instagram.com/p/__XXX__/",
  IG_EMBED: "https://www.instagram.com/embed.js",

  // xigua
  XIGUA_COM: "https://www.ixigua.com/",

  // vimeo
  VIMEO_PLAYER: "https://player.vimeo.com/",
  VIMEO_COM: "https://vimeo.com/",

  // simplecast
  SIMPLECAST_PLAYER: "https://player.simplecast.com/",

  // vika share
  VIKA_SHARE: "https://vika.cn/share/",

  // fireside
  FIRESIDE_SHARE: "https://share.fireside.fm/episode/",
  FIRESIDE_PLAYER: "https://player.fireside.fm/v2/",

  // linkedin
  LINKEDIN_EMBED: "https://www.linkedin.com/embed/",

  // chrome site setting
  CHROME_SITE_SETTING: "chrome://settings/content/siteDetails?site=__XXX__",

  // middle page of third-party when opening a link
  LINK_ZHIHU: "https://link.zhihu.com/",
  LINK_ZHUBAI: "https://link.zhubai.love/api/link",
  LINK_SBSTCK: "https://link.sbstck.com/redirect",
  LINK_SSPAI: "https://sspai.com/link",

  // 163 netease main site
  NETEASE_MAIN: "https://www.163.com/",

  // psyche.co
  PSYCHE_CO: "https://psyche.co/",

  // some blogs
  LUTAONAN_COM: "https://lutaonan.com/",

  // reddit
  REDDIT_COM: "https://www.reddit.com/",
  REDDIT_EMBED: "https://embed.reddit.com/",

  // some dev
  REACT_NATIVE: "https://reactnative.dev/",

  RED_FOLLOW_URL: "https://www.xiaohongshu.com/user/profile/5d1642d80000000011033c24",
  OPEN_SOURCE_URL: "https://github.com/yenche123/liubai",
  
}